import { __extends } from "tslib";
import { Box, Button, Cell, Divider, Heading, Layout, ModalMobileLayout, Text, } from 'wix-style-react';
import * as React from 'react';
import { SelectorCheckBoxMobile } from './selector-checkbox-mobile';
import { config } from '../../../config';
import { composer } from '../../../component-decorators/composer';
export var SubCategoriesSelectorModalMobile = composer()
    .withMarketplaceStore()
    .withTranslation()
    .compose(function (_a) {
    var subCategories = _a.subCategories, categoryName = _a.categoryName, closeModal = _a.closeModal, setCheckedSubCategories = _a.setCheckedSubCategories, checkedSubCategories = _a.checkedSubCategories, marketplaceStore = _a.marketplaceStore, name = _a.name, t = _a.t;
    return (React.createElement(ModalMobileLayout, { title: React.createElement(React.Fragment, null,
            React.createElement(Heading, { appearance: 'H2' }, name),
            React.createElement(Text, { weight: "normal" }, t('category-header-mobile.filter-subcategory.title') + ":")), fullscreen: true, content: React.createElement(SubCategoriesSelectorModalMobileContent, { subCategories: subCategories, categoryName: categoryName, closeModal: closeModal, setCheckedSubCategories: setCheckedSubCategories, checkedSubCategories: checkedSubCategories, name: name }), footer: React.createElement(SubCategoriesSelectorModalMobileFooter, { onChoose: function () {
                config.goto({
                    path: marketplaceStore.route.path,
                    slug: marketplaceStore.route.slug,
                    subCategories: checkedSubCategories.map(function (checked) { return checked.slug; }),
                });
                setCheckedSubCategories(checkedSubCategories);
                closeModal();
            }, onCancel: function () {
                setCheckedSubCategories([]);
                closeModal();
            } }), onCloseButtonClick: function () {
            setCheckedSubCategories([]);
            closeModal();
        }, stickyTitle: true, stickyFooter: true }));
});
var SubCategoriesSelectorModalMobileFooter = composer()
    .withTranslation()
    .compose(function (_a) {
    var onChoose = _a.onChoose, onCancel = _a.onCancel, t = _a.t;
    return (React.createElement(Box, { align: "right" },
        React.createElement(Box, { marginRight: "12px" },
            React.createElement(Button, { priority: "secondary", onClick: onCancel }, t('category-header-mobile.filter-subcategory.cancel'))),
        React.createElement(Button, { onClick: onChoose }, t('category-header-mobile.filter-subcategory.filter'))));
});
var SubCategoriesSelectorModalMobileContent = /** @class */ (function (_super) {
    __extends(SubCategoriesSelectorModalMobileContent, _super);
    function SubCategoriesSelectorModalMobileContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SubCategoriesSelectorModalMobileContent.prototype.render = function () {
        var _a = this.props, subCategories = _a.subCategories, checkedSubCategories = _a.checkedSubCategories, setCheckedSubCategories = _a.setCheckedSubCategories;
        return (React.createElement(Layout, { gap: "18px" },
            React.createElement(SelectorCheckBoxMobile, { subCategory: null, subCategoriesCount: subCategories.length, setCheckedSubCategories: setCheckedSubCategories, checkedSubCategories: checkedSubCategories }),
            React.createElement(Cell, null,
                React.createElement(Divider, null)),
            subCategories.map(function (subCategory) { return (
            // tslint:disable-next-line:jsx-key
            React.createElement(SelectorCheckBoxMobile, { subCategory: subCategory, subCategoriesCount: subCategories.length, setCheckedSubCategories: setCheckedSubCategories, checkedSubCategories: checkedSubCategories })); })));
    };
    return SubCategoriesSelectorModalMobileContent;
}(React.Component));
//# sourceMappingURL=sub-categories-selector-modal-mobile.js.map